import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Text } from '../../ui/Text';

type Props = {
  stripeData: any;
};

const StripeEmbeddedCheckout = ({ stripeData }: Props) => {
  const stripePublishableKey = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY;
  if (!stripePublishableKey)
    return (
      <Text color="error" size="xl">
        Configuration for Stripe is missing, please let the admins know of this issue.
      </Text>
    );
  const stripePromise = loadStripe(stripePublishableKey);
  return (
    <EmbeddedCheckoutProvider
      stripe={stripePromise}
      options={{
        clientSecret: stripeData.clientSecret,
      }}
    >
      <EmbeddedCheckout />
    </EmbeddedCheckoutProvider>
  );
};

export default StripeEmbeddedCheckout;
